 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React, {Component,} from 'react'


import getDisplayName from '../getDisplayName'



























// Serves as a lightweight alternative for a form library, best used for single-field forms
const withForm =
  (fields) =>
  (ComposedComponent) => {
    class FormProps extends Component {constructor(...args) { super(...args); FormProps.prototype.__init.call(this);FormProps.prototype.__init2.call(this);FormProps.prototype.__init3.call(this);FormProps.prototype.__init4.call(this);FormProps.prototype.__init5.call(this); }
      static __initStatic() {this.displayName = `WithForm(${getDisplayName(ComposedComponent)})`}
      __init() {this._mounted = false}

      __init2() {this.state = {
        fields: Object.keys(fields).reduce((obj, name) => {
          obj[name ] = {
            value: fields[name ].getDefault(this.props),
            error: undefined,
            dirty: false
          }
          return obj
        }, {} )
      }}

      __init3() {this.onChange = (e) => {
        const {fields} = this.state
        const {value} = e.target
        const name = e.target.name 
        const field = fields[name]
        this.setState(
          {
            fields: {
              ...fields,
              [name]: {
                ...field,
                value
              }
            }
          },
          () => {
            this.validate(name)
          }
        )
      }}

      __init4() {this.validate = (name) => {
        if (!name) {
          return Object.keys(this.state.fields).reduce((obj, name) => {
            obj[name ] = this.validate(name ) 
            return obj
          }, {} )
        }
        const field = this.state.fields[name]
        const {value, error} = field
        const res = fields[name].validate(value, this.props)

        if (res.error !== error) {
          this.setState({
            fields: {
              ...this.state.fields,
              [name]: {
                ...field,
                error: res.error
              }
            }
          })
        }
        return res
      }}

      __init5() {this.setDirty = (name) => {
        if (!name) {
          Object.keys(this.state.fields).forEach((name) => this.setDirty(name))
          return
        }
        const field = this.state.fields[name ]
        if (!_optionalChain([field, 'optionalAccess', _2 => _2.dirty])) {
          this.setState({
            fields: {
              ...this.state.fields,
              [name]: {
                ...field,
                dirty: true
              }
            }
          })
        }
      }}

      componentDidMount() {
        this._mounted = true
      }

      componentWillUnmount() {
        this._mounted = false
      }

      render() {
        const {fields} = this.state
        // https://github.com/Microsoft/TypeScript/issues/10727
        const {forwardedRef, ...props} = this.props 
        const fieldsRef = (this.props ).fieldsRef
        if (fieldsRef) {
          fieldsRef.current = fields
        }
        return (
          React.createElement(ComposedComponent, {
            setDirtyField: this.setDirty,
            onChange: this.onChange,
            validateField: this.validate,
            fields: fields,
            ref: forwardedRef,
            ...props,}
          )
        )
      }
    } FormProps.__initStatic();

    return React.forwardRef((props, ref) => (
      React.createElement(FormProps, { ...props, forwardedRef: ref,} )
    ))
  }

export default withForm
